import React, { useEffect } from "react";
import { Table, Placeholder, Badge, Button, Row, Col, Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { FaArrowLeft } from "react-icons/fa";
import { analyticsActions } from "../../actions/analytics.actions";

function ExecutionDetail(props) {
  const dispatch = useDispatch();
  const analyticsReducer = useSelector((state) => state.analytics);

  useEffect(() => {
    if (!props.user || !props.execution) return;

    // For super users, use the execution's client info; for regular users, use their own
    const clientId = props.execution.clientId || props.user.clientId;
    const clientGuid = props.execution.clientGuid || props.user.clientGuid;

    if (!clientId) return;

    const queryParams = {
      clientId: clientId,
      clientGuid: clientGuid,
      executionId: props.execution.executionId,
    };

    dispatch(analyticsActions.getExecutionDetail(queryParams));
    // eslint-disable-next-line
  }, [props.user, props.execution]);

  const executionDetail = analyticsReducer.executionDetail;
  const loading = analyticsReducer.loadingExecutionDetail;

  return (
    <div>
      <Button variant="outline-secondary" size="sm" onClick={props.onBack} className="mb-3">
        <FaArrowLeft className="me-2" />
        Back to Executions
      </Button>

      {loading && (
        <Placeholder as={"div"} animation="glow">
          <Placeholder xs={12} size="lg" style={{ height: "400px" }} />
        </Placeholder>
      )}

      {!loading && executionDetail && (
        <>
          <h5 className="mb-3">Execution Detail</h5>

          <Card className="mb-4">
            <Card.Body>
              <Row>
                <Col md={6}>
                  <p><strong>Execution ID:</strong> <code>{executionDetail.executionId}</code></p>
                  <p><strong>Runbook:</strong> {executionDetail.runbookName} ({executionDetail.runbookId})</p>
                  <p><strong>Status:</strong>{" "}
                    <Badge bg={executionDetail.status === "Success" ? "success" : "danger"}>
                      {executionDetail.status}
                    </Badge>
                  </p>
                  <p><strong>Trigger:</strong> {executionDetail.executionTrigger}</p>
                  {executionDetail.environment && (
                    <p><strong>Environment:</strong> {executionDetail.environment}</p>
                  )}
                </Col>
                <Col md={6}>
                  <p><strong>Start Time:</strong> {new Date(executionDetail.startTime).toLocaleString()}</p>
                  <p><strong>End Time:</strong> {new Date(executionDetail.endTime).toLocaleString()}</p>
                  <p><strong>Total API Calls:</strong> {executionDetail.totalApiCalls}</p>
                  <p><strong>Successful Calls:</strong> <span className="text-success">{executionDetail.successfulApiCalls}</span></p>
                  <p><strong>Failed Calls:</strong> <span className="text-danger">{executionDetail.failedApiCalls}</span></p>
                  <p><strong>Success Rate:</strong>{" "}
                    <Badge bg={executionDetail.successRate >= 90 ? "success" : executionDetail.successRate >= 70 ? "warning" : "danger"}>
                      {executionDetail.successRate.toFixed(2)}%
                    </Badge>
                  </p>
                  <p><strong>Records Returned:</strong> {executionDetail.totalRecordsReturned.toLocaleString()}</p>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          <h6 className="mb-3">API Calls Breakdown</h6>
          {executionDetail.apiCalls && executionDetail.apiCalls.length > 0 ? (
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>API System</th>
                  <th>Object</th>
                  <th>Action</th>
                  <th>Total Calls</th>
                  <th>Successful</th>
                  <th>Failed</th>
                  <th>Success Rate</th>
                  <th>Records</th>
                </tr>
              </thead>
              <tbody>
                {executionDetail.apiCalls.map((apiCall, index) => (
                  <tr key={index}>
                    <td><strong>{apiCall.apiSystem}</strong></td>
                    <td>{apiCall.apiObject}</td>
                    <td>{apiCall.apiAction}</td>
                    <td>{apiCall.totalCalls}</td>
                    <td className="text-success">{apiCall.successfulCalls}</td>
                    <td className="text-danger">{apiCall.failedCalls}</td>
                    <td>
                      <Badge bg={apiCall.successRate >= 90 ? "success" : apiCall.successRate >= 70 ? "warning" : "danger"}>
                        {apiCall.successRate.toFixed(2)}%
                      </Badge>
                    </td>
                    <td>{apiCall.recordsReturned.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div className="text-center text-muted py-3">
              <p>No API call data available</p>
            </div>
          )}
        </>
      )}

      {!loading && !executionDetail && (
        <div className="text-center text-muted py-5">
          <p>Execution details not found</p>
        </div>
      )}
    </div>
  );
}

export default ExecutionDetail;
